
import {defineComponent, ref, watch, PropType} from 'vue';
import {useToast} from 'primevue/usetoast';
import {useConfirm} from 'primevue/useconfirm';
import BangChon from './BangChon.vue';
import repository from '@/services/BenhNhanRepository';

interface Group {id:number; idKhoaPhong:number; tenNhom:string; dichVuIds:number[]; nhanVienChinhIds:number[]; nhanVienPhuIds:number[]}
const empty = ():Group => ({id:0,idKhoaPhong:0,tenNhom:'',dichVuIds:[],nhanVienChinhIds:[],nhanVienPhuIds:[]});
export default defineComponent({
  components:{BangChon},
  props:{khoa:{type:Number,required:true},tenKhoa:{type:String,default:''},services:{type:Array as PropType<any[]>,required:true},staff:{type:Array as PropType<any[]>,required:true}},
  emits:['changed','busy'],
  setup(props,{emit,expose}) {
    const toast=useToast(),confirm=useConfirm();
    const groups=ref([] as Group[]),form=ref(empty()),editing=ref(false),busy=ref(false),loading=ref(false);
    let generation=0;
    const tai=async()=>{
      const khoa=props.khoa,version=++generation;
      if(!khoa){groups.value=[];return;}
      loading.value=true;
      try {const r=await repository.getNhomDichVu(khoa);if(version===generation&&khoa===props.khoa)groups.value=r.data;}
      catch(err){if(version===generation){toast.add({severity:'error',summary:'Không tải được nhóm dịch vụ',detail:err.response?.data||'Vui lòng thử lại',life:4000});}throw err;}
      finally{if(version===generation)loading.value=false;}
    };
    const sua=(group?:Group)=>{form.value=group?JSON.parse(JSON.stringify(group)):empty();form.value.idKhoaPhong=props.khoa;editing.value=true;};
    const setBusy=(value:boolean)=>{busy.value=value;emit('busy',value);};
    const luu=async()=>{
      if(busy.value)return;
      setBusy(true);
      try {
        await repository.luuNhomDichVu({...form.value,idKhoaPhong:props.khoa});
        await tai();editing.value=false;emit('changed');
        toast.add({severity:'success',summary:'Đã lưu nhóm dịch vụ',detail:'Phân công từ nhóm sẽ áp dụng cho lần chia giờ tiếp theo.',life:3500});
      }catch(err){toast.add({severity:'error',summary:'Không lưu được nhóm',detail:err.response?.data||'Vui lòng thử lại',life:4500});}
      finally{setBusy(false);}
    };
    const xoa=(group?:Group)=>{
      const khoa=props.khoa;
      confirm.require({group:'templating',header:'Xác nhận xóa nhóm dịch vụ',icon:'pi pi-exclamation-triangle',
        message:`Xóa ${group?`nhóm “${group.tenNhom}”`:'tất cả nhóm dịch vụ'} của ${props.tenKhoa} (mã ${khoa})? Quyền thực hiện từ nhóm sẽ bị gỡ; danh sách dịch vụ đã duyệt, nhân viên khoa và phân công trực tiếp được giữ lại.`,
        acceptLabel:'Xác nhận xóa',rejectLabel:'Hủy',defaultFocus:'reject',acceptClass:'p-button-danger',
        accept:async()=>{
          if(busy.value||khoa!==props.khoa)return;
          setBusy(true);
          try{if(group)await repository.xoaNhomDichVu(khoa,group.id);else await repository.xoaTatCaCauHinh(khoa,'nhomDichVu');await tai();emit('changed');toast.add({severity:'success',summary:'Đã xóa nhóm dịch vụ',life:3000});}
          catch(err){toast.add({severity:'error',summary:'Không xóa được nhóm',detail:err.response?.data||'Vui lòng thử lại',life:4000});}
          finally{setBusy(false);}
        }
      });
    };
    watch(()=>props.khoa,()=>{editing.value=false;groups.value=[];tai().catch(()=>{});},{immediate:true});
    expose({tai});
    return{groups,form,editing,busy,loading,tai:()=>tai().catch(()=>{}),sua,luu,xoa};
  }
});
